import cn from 'clsx';

import {Text} from '@/components/Typography';
import {getContent} from '@/services/content/content';
import type {TipData} from '@/types/experienceScore';

import TipNotificationStack from './TipNotificationStack';

interface TipsToConsiderProps {
    tipsToConsiderData?: TipData[];
    isTitleVisible?: boolean;
    containerClassName?: string;
    liveTourTarget?: string;
}

const TipsToConsider = ({
    tipsToConsiderData = [],
    isTitleVisible = true,
    containerClassName,
    liveTourTarget,
}: TipsToConsiderProps) => {
    const {tipsTitle} = getContent().experienceScoreContent ?? {};

    if (tipsToConsiderData.length === 0) return null;

    return (
        <div
            className={cn('flex w-full flex-col items-center gap-4', containerClassName)}
            data-live-tour-target={liveTourTarget}
        >
            {isTitleVisible && (
                <Text as='h2' variant='subsectionTitle' className='w-full text-left'>
                    {tipsTitle}
                </Text>
            )}
            <TipNotificationStack tips={tipsToConsiderData} className='w-full' />
        </div>
    );
};

export default TipsToConsider;
